module.exports = __webpack_public_path__ + "c64fc602c9a68cd69953e84a2f12ce08.png";